<template>
  <InputNumberWrapper class="input-unit" :unit="unit" :width="width">
    <input
      :id="id"
			ref="input"
			:name="name"
			:placeholder="placeholder"
			:type="'number'"
			:value="inputValue"
			:class="['form-control fs-sa-14 text-right pr-20 no-wheel', inputClasses]"
			:disabled="disabled"
			:readonly="readOnly"
			@focus="inputFocus"
			@blur="inputBlur($event.target.value)"
			@change="inputChange($event.target.value)"
			@input="inputEvent($event.target.value)"
			@keyup="inputKeyUp($event)"
			@keyup.enter="inputKeyEnter($event.target.value)"
    />
  </InputNumberWrapper>
</template>

<script>
import { InputNumberWrapper } from "./FormInputNumber2.styled";

export default {
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      default: 0,
    },
    unit: {
      type: String,
      default: "",
    },
    max: {
      type: Number,
      default: null
    },
    min: {
      type: Number,
      default: 0
    },
    id: {
			type: String,
			default: null,
		},
		name: {
			type: String,
			default: null
		},
		disabled: {
			type: Boolean,
			default: false
		},
		readOnly: {
			type: Boolean,
			default: false
		},
		inputClasses: {
			type: String,
			default: ''
		},
		focus: {
			type: Function,
			default: null
		},
		blur: {
			type: Function,
			default: null
		},
		change: {
			type: Function,
			default: null
		},
		keyUp: {
			type: Function,
			default: null
		},
		keyEnter: {
			type: Function,
			default: null
		},
		width: {
			type: Number,
			default: 72
		}
  },
  data: () => ({
    inputValue: 0,
		inputFocused: false,
    whiteListUnit: ['px','°']
	}),
  mounted () {
    this.inputValue = this.value;
  },
  methods: {
    inputBlur (value) {
			this.inputFocused = false;
			if(this.blur) {
				this.blur(value);
			}
			this.$emit('blur', parseInt(value));
		},
		inputFocus () {
			this.inputFocused = true;
			if(this.focus) {
				this.focus();
			}
			this.$emit('focus');
		},
		inputChange (value) {
			if(this.change) {
				this.change(value);
			}
			this.$emit('change', parseInt(value));
		},
		inputKeyUp (e) {
			this.$emit('keyUp', e);
			if(this.keyUp) {
				this.keyUp(e);
			}
		},
		inputKeyEnter (value) {
			this.$emit('keyEnter', parseInt(value));
			if(this.keyEnter) {
				this.keyEnter(value);
			}
			this.$refs.input.blur()
		},
    inputEvent(value) {
      let callbackValue = this.checkMinMax(value)
      this.$emit('input', parseInt(callbackValue))
      this.$forceUpdate();
      // this.$emit('change', parseInt(callbackValue));
    },
    checkMinMax(value) {
      // value = Math.max(this.min, Math.min(this.max, value)); // boundary
      if (this.min != undefined && value  <= this.min) {
        value = this.min
      } else if (this.max && value  >= this.max) {
        value = this.max
      }
      this.inputValue = parseInt(value)
      return parseInt(value)
    }
  },
  watch: {
    value(val) {
      this.inputValue = val
    }
  },
  components: {
    InputNumberWrapper,
  },
};
</script>

<style lang="scss" scoped>
.no-wheel {
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
</style>
